module.exports = __webpack_public_path__ + "img/stock2.6138cfd9.png";